import { configureStore } from '@reduxjs/toolkit';
import {  fetchchangepassworddatareducer } from './components/Reuseablecomponents/Details/Securitydetails/Securityslice';
import { loginwithapireducer } from './pages/Loginpage/Loginpageslice';
import {fetchuserprofiledatareducer} from "./pages/Myaccountpage/Myaccountmatchesslice"


const Store = configureStore({
    reducer: {
        Userprofiledata: fetchuserprofiledatareducer,
        Loginapi: loginwithapireducer,
        Changepassworddata: fetchchangepassworddatareducer
    },
});

export type RootState = ReturnType<typeof Store.getState>
// Inferred type: {posts: PostsState, comments: CommentsState, users: UsersState}
export type AppDispatch = typeof Store.dispatch

export default Store;